module.exports = __webpack_public_path__ + "static/media/icon-home.11d89f06.svg";